import { render } from "./DeviceSettingsTable.vue?vue&type=template&id=e8165dcc"
import script from "./DeviceSettingsTable.vue?vue&type=script&lang=js"
export * from "./DeviceSettingsTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__